import type { ClientRecord } from 'hooks/api/use-clients';

interface FileDataLike {
  name?: string;
  [key: string]: unknown;
}

export interface BreadcrumbEntry {
  label: string;
  href?: string;
  isActive?: boolean;
}

export const getBreadcrumbsForFile = (
  currentClient: ClientRecord | null | undefined,
  fileData: FileDataLike | null | undefined,
): BreadcrumbEntry[] => {
  const baseBreadcrumbs: BreadcrumbEntry[] = [
    { label: 'Clients', href: '/admin/clients' },
    {
      label: currentClient?.name ?? '',
      href: `/admin/clients/${currentClient?.id}`,
    },
    {
      label: 'Files',
      href: `/admin/clients/${currentClient?.id}/files`,
    },
  ];

  baseBreadcrumbs.push({
    label: fileData?.name || 'New file',
    isActive: true,
  });

  return baseBreadcrumbs;
};
